/* eslint-disable */

import $ from "jquery";

/**
 * Scroll to top
 */

const ScrollTop = () => {
  const setFocus = () => {
    $(".skip-links").attr("tabindex", "0");
    $(".skip-links").focus();
  };

  document.querySelector(".jump-top").addEventListener(
    "click",
    () => {
      const topInterval = setInterval(() => {
        const scrollToTop =
          document.body.scrollTop > 0
            ? document.body
            : document.documentElement;

        if (scrollToTop.scrollTop > 0) {
          scrollToTop.scrollTop -= 50;
          setFocus();
        }

        if (scrollToTop.scrollTop < 1) {
          clearInterval(topInterval);
        }
      }, 25);
    },
    false
  );

  document.querySelector(".jump-top").addEventListener("keyup", e => {
    if (e.keyCode == 13) {
      const topInterval = setInterval(() => {
        const scrollToTop = document.body.scrollTop > 0 ? document.body : document.documentElement;

        if (scrollToTop.scrollTop > 0) {
          scrollToTop.scrollTop -= 50;
          setFocus();
        }

        if (scrollToTop.scrollTop < 1) {
          clearInterval(topInterval);
        }
      }, 25);
    }
  }, false);

  const footer = document.querySelector("footer");
  const feedback = document.querySelector(".feedback-container");
  const header = document.querySelector("header");
  const feedbackButton = document.getElementById("feedback");

  function setWidth(){
    feedbackButton.style.right = 15 + 'px';
  };

  function removeSetWidth() {
    feedbackButton.style.right = "15px";
  }

  const inViewport = e => {
    const bb = e.getBoundingClientRect();
    // Check if the element is outside the viewport
    return !(bb.top > innerHeight || bb.bottom < 0);
  };

  document.addEventListener(
    "scroll",
    () => {
      // Check the viewport status and if footer has entered viewport
      if (inViewport(footer)) {
        feedback.classList.add("footer-reached");

        // Remove right value when footer reached
        removeSetWidth()
      } else {
        feedback.classList.remove("footer-reached");

        // Set custom right value based on window
        setWidth();
      }

      if (window.pageYOffset >= header.offsetHeight) {
        feedback.classList.add("fade-in");
      }

      if (window.pageYOffset <= header.offsetHeight) {
        feedback.classList.remove("fade-in");
      }
    },
    false
  );

};

document.addEventListener("DOMContentLoaded", () => {
  const feedback = document.querySelector(".feedback-container");
  const mainHeight = document.querySelectorAll('main')[0];
  const windowHeight = window.innerHeight;
  const eHeight = mainHeight.scrollHeight;

  if (windowHeight > eHeight) {
    feedback.classList.add("footer-reached");
    feedback.classList.add("no-overflow-content");
  }
});

export default ScrollTop;
/* eslint-enable */
